import i18n from '@/i18n';
import { carClasses } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const CarClasses = () => import('./views/Index.vue');

export default [
  {
    path: 'car-classes',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.CarClasses`,
        component: CarClasses,
        meta: {
          title: i18n.global.t('carClasses.carClasses'),
          permission: { module: carClasses.module, key: carClasses.showAll },
        },
      },
    ],
  },
];
